<template>
    <modal name="create_make" height="auto" scrollable adaptive>
        <app-card :title="$t('Create make')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <make-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import MakesModelsService from '@services/makesModels.service';
import MakeForm from './components/MakeForm';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                name: null,
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    MakesModelsService.storeMake(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setMake', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_make');
        }
    },
    components: {
        MakeForm
    }
};
</script>
